import type { TFunction } from 'i18next'

import locales from '@src/config/locales'

export function getOrganizationsLinks(t: TFunction, locale: string) {
  return [
    {
      title: t('privateDelivery'),
      link: `${locales[locale].organizationsPath}#groupes`,
    },
    {
      title: t('learningWorkshops'),
      link: `${locales[locale].organizationsPath}#ateliers`,
    },
    {
      title: t('businessCoaching'),
      link: `${locales[locale].organizationsPath}#coaching`,
    },
    {
      title: t('customPrograms'),
      link: `${locales[locale].organizationsPath}#programmes`,
    },
    {
      title: t('privateConferences'),
      link: t('privateConferencesLink'),
    },
  ]
}
